import React, { useEffect, useRef, useState } from "react";
import { useDragDrop } from "../../../utils/common";
import {
  ModalCrosSvg,
  UploadImgSvg,
  ImageCroseSvg,
} from "../../../images/Svgs";
import { Addmssage } from "../../../API/routine";
import { toast } from "react-toastify";
const initionalEvent = {
  event_id: "",
  title: "",
  description: "", 
  upload_photo: "",
};
const AddMessage = ({ onSetModal, EventId }) => {
  const imageInputRef = useRef(null);
  const [eventData, setEventData] = useState(initionalEvent);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [fileName, setFileName] = useState();
  const [dragActive, setDragActive] = useState(false);
  const [eventError, setEventError] = useState({
    title: "",
    description: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEventData({ ...eventData, [name]: value });
    setEventError({ ...eventError, [name]: "" });
  };

  // Validate form inputs
  const validateForm = () => {
    let errors = {};
    let isValid = true;

    // Title validation
    if (!eventData.title) {
      errors.title = "Title is required.";
      isValid = false;
    }
    // Description validation
    if (eventData.description === "") {
      errors.description = "Description is required.";
      isValid = false;
    }
    setEventError(errors);
    return isValid;
  };
  const handleImageUploadClick = () => {
    imageInputRef.current.click();
  };

  const allowedImageTypes = ["image/png", "image/jpeg"];
  const handleFile = (file) => {
    if (file && allowedImageTypes.includes(file.type)) {
      setFileName(file.name);
      setSelectedImage(file);
    }
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        let formData = new FormData();
        formData.append("title", eventData?.title);
        formData.append("description", eventData?.description);
        formData.append("event_id", EventId);
        formData.append("upload_photo", selectedImage || null);
        const response = await Addmssage(formData);
        if (response?.status) {
          toast.success(response.message || "success !");
          onSetModal(false);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error("Error during login request:", error);
      }
    } else {
      console.log("Form has errors.");
    }
  };
  //for drag drop file
  const { handleDragOver, handleDragLeave, handleDrop } = useDragDrop(
    handleFile,
    setDragActive,
    setDragActive,
    handleFile
  );

  return (
    <div className="modal fade show">
      <div className="modal-dialog add_new_event_box">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5 font-18" id="exampleModalLabel">
              Add Message
            </h1>
            <button
              type="button"
              className="new_event_lose inter"
              onClick={() => onSetModal(false)}
            >
              <ModalCrosSvg />
            </button>
          </div>
           <div className="modal-body">
            <input
              type="text"
              className="form-control"
              placeholder="Message Title"
              name="title"
              value={eventData?.title}
              maxLength={50}
              onChange={(e) => handleChange(e)}
            />
            {eventError.title && (
              <div className="text-danger">{eventError.title}</div>
            )}
            <textarea
              className="form-control mt-3 inter font-12"
              id="exampleFormControlTextarea1"
              rows="4"
              placeholder="Add Descriptions"
              name="description"
              value={eventData?.description}
              onChange={(e) => handleChange(e)}
            ></textarea>
            {eventError.description && (
              <div className="text-danger">{eventError.description}</div>
            )}
            <div className="mt-3">
              <div
                className="event_file"
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <div className="upload-btn-wrapper">
                  <button
                    className="vitalu_cont"
                    onClick={handleImageUploadClick}
                  >
                    <div className="upload_icon">
                      <UploadImgSvg />
                    </div>
                    <div className="vital_text_png">
                      <span>Click to upload photo</span> or drag and drop
                    </div>
                  </button>
                  <input
                    type="file"
                    accept=".png,.jpg"
                    ref={imageInputRef}
                    name="upload_photo"
                    draggable="true"
                    onChange={(e) => handleFile(e.target.files[0])}
                  />
                </div>
                {fileName && (
                  <>
                    <h2 className="inter">Uploaded photo</h2>
                    <div className="sample_file_icon">
                      <div className="sample_file">
                        <p className="inter">{fileName}</p>
                      </div>
                      <div
                        className="sample_file"
                        onClick={() => setFileName("")}
                      >
                        <ImageCroseSvg />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn cancelbtn_event inter"
                onClick={() => onSetModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="blackbtn savebtn_event inter"
                onClick={(e) => handleSubmit(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMessage;
